import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * A React Hook
 * Uses search params to handle search queries
 * @returns
 */
export default function useSearch(_limit = null) {
    /* Search functionality */
    const [searchParams, setSearchParams] = useSearchParams();
    const searchQuery = useMemo(() => {
        const query = {};
        const entries = [...searchParams.entries()];
        // Patch for old search query
        const searchEntry = entries.find(([k]) => k.toLowerCase() === 'search');
        if (searchEntry?.length === 2) {
            setSearchParams((prevSearchParams) => {
                prevSearchParams.set('q', searchEntry[1]);
                prevSearchParams.delete(searchEntry[0]);
                return prevSearchParams;
            });
        } else {
            for (const [k, v] of entries) {
                if (!(k in query)) {
                    if (k.toLowerCase() === 'search') {
                        query.q = v;
                        continue;
                    }
                    query[k] = v;
                } else if (Array.isArray(query[k])) {
                    query[k].push(v);
                } else {
                    query[k] = [query[k], v];
                }
            }
            return query;
        }
    }, [searchParams, setSearchParams]);
    const updateSearchParams = (newSearchQueryParams = {}) => {
        const result = {};
        let resetPage = false;
        let resetFilters = false;
        for (const [param, paramVal] of Object.entries(newSearchQueryParams)) {
            if (!paramVal) {
                continue;
            }
            result[param] = paramVal;
            if (param !== 'page'
                && (typeof paramVal !== 'string'
                    || paramVal !== searchParams.get(param))) {
                resetPage = true;
                if (param === 'q') {
                    resetFilters = true;
                }
            }
        }
        if (resetPage === true) {
            result.page = 0;
        }
        if (resetFilters === true) {
            result.t = [];
            result.c = [];
            result.v = '';
        }
        setSearchParams(result);
    };
    return {
        searchQuery,
        updateSearchParams,
    };
}